/* A-PACHINKO WORLD 独自スクリプト（head から移動）
   2026-10-23: layout/theme.liquid の <head> にインラインで入っていた 11本・38831字をここへ移動。
   defer で読み込むので「HTMLを読み終えてから、元と同じ順番で」実行される。中身は一切変更していない。
   戻す場合: deploy-backups/seo-20261023/layout_theme.before-extjs.liquid */

/* ===== 元 head の script #4：配送アイコンの表示 ===== */
try {

;(function(){
  var ICON = "<svg class=\"apw-shipping-icon\" width=\"20\" height=\"20\" viewBox=\"0 0 44 44\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" style=\"vertical-align:-4px;margin-right:8px;flex-shrink:0\"><path d=\"M23.6498 42.7423C23.4202 42.8471 23.1714 42.9032 22.919 42.9073C22.6666 42.9114 22.4161 42.8634 22.1832 42.7662L2.044 34.3768C1.71005 34.2375 1.4248 34.0025 1.22416 33.7014C1.02352 33.4003 0.916474 33.0465 0.916504 32.6847V11.275C0.916331 10.9181 1.02032 10.569 1.21572 10.2703C1.41111 9.9717 1.68942 9.73659 2.0165 9.59384L21.2665 1.22467C21.4978 1.12372 21.7475 1.07162 21.9998 1.07162C22.2522 1.07162 22.5019 1.12372 22.7332 1.22467L41.9832 9.59384C42.3103 9.73659 42.5886 9.9717 42.784 10.2703C42.9794 10.569 43.0833 10.9181 43.0832 11.275V32.725C43.0834 33.0772 42.9822 33.422 42.7917 33.7182C42.6012 34.0143 42.3294 34.2494 42.0088 34.3952L23.6498 42.7423Z\" stroke=\"#A81818\" stroke-width=\"2.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M22.9165 19.239V42.9275\" stroke=\"#A81818\" stroke-width=\"2.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M22.9165 19.239L42.7513 10.2245\" stroke=\"#A81818\" stroke-width=\"2.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M32.0337 5.269L11.9165 14.531V21.2392\" stroke=\"#A81818\" stroke-width=\"2.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M22.9167 19.239L1.25586 10.2135\" stroke=\"#A81818\" stroke-width=\"2.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>";
  // APW skip machine shipping hint on option products
  function isOptionProductPage(){
    if (/\/collections\/all-options\/products\//.test(window.location.pathname)) return true;

    var scripts = document.querySelectorAll ? document.querySelectorAll('script[type="application/ld+json"]') : [];
    for (var i = 0; i < scripts.length; i += 1) {
      var text = scripts[i].textContent || '';
      if (/"category"\s*:\s*"(?:Common option|Pachinko option|Slot option)"/i.test(text)) return true;
    }

    var productJson = document.querySelector ? document.querySelector('script[type="application/json"][data-product-json], #ProductJson-product-template') : null;
    if (productJson) {
      try {
        var product = JSON.parse(productJson.textContent);
        var type = String(product.type || product.product_type || '').toLowerCase();
        if (type === 'common option' || type === 'pachinko option' || type === 'slot option') return true;
      } catch(e) {}
    }

    return false;
  }
  // APW option shipping quote hint
  function injectOptionShippingHint(){
    if (document.querySelector('.apw-option-shipping-hint')) return;
    var price = document.querySelector('.price--main, .product-price--regular, [data-product-price], .product__price, .product-details .price');
    if (!price) {
      price = document.querySelector('.product-block--price, .product-details > div > .price');
    }
    if (!price) return;

    var hint = document.createElement('div');
    hint.className = 'apw-option-shipping-hint';
    hint.innerHTML = '<div class="apw-shipping-row">' + ICON +
      '<div class="apw-shipping-body"><strong>Shipping quote required for option items</strong>' +
      'The product price does not include international shipping. For option and accessory-only orders, shipping varies by destination, address, package size, and current FedEx rates.' +
      '<span class="apw-secondary">After your order is placed, we will confirm the packed size, request a FedEx quote based on your address, and send a separate shipping invoice before dispatch. If this item can be packed with a machine, additional shipping may be reduced or not required.</span>' +
      '</div></div>';

    var parent = price.parentNode;
    if (parent) parent.insertBefore(hint, price.nextSibling);
  }
  function injectShipping(){
    if (!document.body.classList.contains('template-product')) return;
    if (isOptionProductPage()) { injectOptionShippingHint(); return; }
    if (document.querySelector('.apw-shipping-hint')) return;
    var price = document.querySelector('.price--main, .product-price--regular, [data-product-price], .product__price, .product-details .price');
    if (!price) {
      price = document.querySelector('.product-block--price, .product-details > div > .price');
    }
    if (!price) return;
    var hint = document.createElement('div');
    hint.className = 'apw-shipping-hint';
    hint.innerHTML = '<div class="apw-shipping-row">' + ICON +
      '<div class="apw-shipping-body"><strong>+ approx. ' + String.fromCharCode(36) + '600 shipping to USA</strong> &middot; 3-4 weeks to prepare, then 15-20 days in transit' +
      '<span class="apw-secondary">Europe ~' + String.fromCharCode(36) + '700 &middot; Asia ~' + String.fromCharCode(36) + '500 &middot; See <a href="/pages/shipping-fee-information" style="color:#A81818;font-weight:bold">all regions</a></span>' +
      '</div></div>';
    var parent = price.parentNode;
    if (parent) parent.insertBefore(hint, price.nextSibling);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', injectShipping);
  else injectShipping();
})();

} catch (e) { if (window.console && console.warn) { console.warn('APWブロック #4 で例外が出ましたが、他の機能は続行します:', e); } }

/* ===== 元 head の script #5：お気に入り（wishlist） ===== */
try {

;(function(){
    var KEY = 'apw_wishlist';
    function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e){ return []; } }
    function write(arr) { localStorage.setItem(KEY, JSON.stringify(arr)); }
    function has(h) { return read().indexOf(h) >= 0; }
    function toggle(h) {
      var arr = read(); var i = arr.indexOf(h);
      if (i >= 0) arr.splice(i, 1); else arr.push(h);
      write(arr); return arr;
    }
    function updateCounters() {
      var n = read().length;
      document.querySelectorAll('.apw-wishlist-link').forEach(function(el){
        el.setAttribute('data-count', String(n));
        var c = el.querySelector('.apw-wishlist-count');
        if (c) c.textContent = n > 0 ? String(n) : '';
      });
    }

    // Inject header link into nav if not present
    function injectHeaderLink() {
      if (document.querySelector('.apw-wishlist-link')) return;
      var nav = document.querySelector('.header__cart, [data-header-cart], .site-header__cart, .header-cart');
      if (!nav) return;
      var a = document.createElement('a');
      a.href = '/pages/wishlist';
      a.className = 'apw-wishlist-link';
      a.setAttribute('aria-label', 'Wishlist');
      a.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
                 '<span>Wishlist</span><span class="apw-wishlist-count"></span>';
      nav.parentNode.insertBefore(a, nav);
      updateCounters();
    }

    // Inject Save/Saved button on PDP
    function injectPDPButton() {
      var form = document.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      if (form.querySelector('.apw-wishlist-btn')) return;
      // Get product handle from URL
      var m = window.location.pathname.match(/\/products\/([a-z0-9-]+)/i);
      if (!m) return;
      var handle = m[1];

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'apw-wishlist-btn' + (has(handle) ? ' is-saved' : '');
      btn.innerHTML = '<svg class="apw-wishlist-icon" viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
                     '<span class="apw-wishlist-label">' + (has(handle) ? 'Saved' : 'Save') + '</span>';
      btn.addEventListener('click', function(){
        toggle(handle);
        var saved = has(handle);
        btn.classList.toggle('is-saved', saved);
        btn.querySelector('.apw-wishlist-label').textContent = saved ? 'Saved' : 'Save';
        updateCounters();
      });
      // Insert after Add to Cart button
      var cartBtn = form.querySelector('[type="submit"], button[name="add"]');
      if (cartBtn && cartBtn.parentNode) {
        cartBtn.parentNode.insertBefore(btn, cartBtn.nextSibling);
      } else {
        form.appendChild(btn);
      }
    }

    function init() {
      injectHeaderLink();
      injectPDPButton();
      updateCounters();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

} catch (e) { if (window.console && console.warn) { console.warn('APWブロック #5 で例外が出ましたが、他の機能は続行します:', e); } }

/* ===== 元 head の script #6：フッターのリンク ===== */
try {

;(function(){
    if (document.querySelector('.apw-footer-links')) return;
    function inject(){
      var footer = document.querySelector('.site-footer, footer.site-footer, [role="contentinfo"], #shopify-section-footer-group, .footer-group-wrapper');
      var wrapper = document.createElement('div');
      wrapper.innerHTML = "<aside class=\"apw-footer-links\" aria-label=\"Browse our catalog\">\n  <div class=\"apw-footer-links-inner\">\n    <div class=\"apw-footer-links-grid\">\n      <div class=\"apw-footer-links-col\">\n        <h3>Shop by IP</h3>\n        <ul>\n          <li><a href=\"/pages/evangelion-pachinko-pachislot\">Evangelion</a></li>\n          <li><a href=\"/pages/fist-of-the-north-star-pachinko-pachislot\">Fist of the North Star</a></li>\n          <li><a href=\"/pages/lupin-the-third-pachinko-pachislot\">Lupin the Third</a></li>\n          <li><a href=\"/pages/madoka-magica-pachinko-pachislot\">Madoka Magica</a></li>\n          <li><a href=\"/pages/resident-evil-biohazard-pachinko-pachislot\">Resident Evil</a></li>\n          <li><a href=\"/pages/sword-art-online-pachinko-pachislot\">Sword Art Online</a></li>\n          <li><a href=\"/pages/rezero-pachinko-pachislot\">Re:Zero</a></li>\n          <li><a href=\"/pages/garo-pachinko-pachislot\">Garo</a></li>\n        </ul>\n      </div>\n      <div class=\"apw-footer-links-col\">\n        <h3>Shop by Maker</h3>\n        <ul>\n          <li><a href=\"/pages/sankyo-pachinko-pachislot-machines\">SANKYO</a></li>\n          <li><a href=\"/pages/sammy-pachinko-pachislot-machines\">Sammy</a></li>\n          <li><a href=\"/pages/newgin-pachinko-machines\">Newgin</a></li>\n          <li><a href=\"/pages/sanyo-pachinko-machines\">SANYO</a></li>\n          <li><a href=\"/pages/kyoraku-pachinko-pachislot-machines\">Kyoraku</a></li>\n          <li><a href=\"/pages/nishijin-pachinko-machines\">Nishijin</a></li>\n          <li><a href=\"/pages/heiwa-pachinko-machines\">Heiwa</a></li>\n          <li><a href=\"/pages/daito-giken-pachinko-pachislot-machines\">Daito Giken</a></li>\n        </ul>\n      </div>\n      <div class=\"apw-footer-links-col\">\n        <h3>Ship to your country</h3>\n        <ul>\n          <li><a href=\"/pages/pachinko-machines-usa\">United States</a></li>\n          <li><a href=\"/pages/pachinko-machines-germany\">Germany</a></li>\n          <li><a href=\"/pages/pachinko-machines-canada\">Canada</a></li>\n          <li><a href=\"/pages/pachinko-machines-australia\">Australia</a></li>\n          <li><a href=\"/policies/shipping-policy\">Shipping Policy</a></li>\n          <li><a href=\"/pages/coin-feeder-no-coin\">Customs by Country</a></li>\n          <li><a href=\"/pages/coin-feeder-no-coin\">Voltage &amp; Power Setup</a></li>\n          <li><a href=\"/pages/coin-feeder-no-coin\">Coin Feeder / No-Coin</a></li>\n        </ul>\n      </div>\n      <div class=\"apw-footer-links-col\">\n        <h3>Help &amp; Guides</h3>\n        <ul>\n          <li><a href=\"/pages/coin-feeder-no-coin\">Coin Feeder &amp; No-Coin</a></li><li><a href=\"/pages/pachinko-ball-setup\">Pachinko Ball Setup</a></li><li><a href=\"/pages/data-counters\">Data Counters &amp; Lamps</a></li><li><a href=\"/blogs/staff-blog-1/complete-international-buyers-guide-japanese-pachinko-pachislot\">International Buyer's Guide</a></li>\n          <li><a href=\"/pages/what-is-pachinko-pachislot\">How Pachinko Works</a></li>\n          <li><a href=\"/pages/what-is-pachinko-pachislot\">How Pachislot Works</a></li>\n          <li><a href=\"/pages/faq\">FAQ</a></li>\n          <li><a href=\"/pages/all-reviews\">Customer Reviews</a></li>\n          <li><a href=\"/pages/wishlist\">Your Wishlist</a></li>\n          <li><a href=\"/pages/compare\">Compare Machines</a></li>\n          <li><a href=\"/pages/contact-us\">Contact Support</a></li>\n        </ul>\n      </div>\n    </div>\n    <p class=\"apw-footer-links-tagline\">\n      <strong>A-PACHINKO World</strong> &mdash; Authentic Japanese pachinko &amp; pachislot machines, overhauled in Okayama and shipped worldwide.<br>\n      JET SQUARE K.K. &middot; 7-day arrival warranty &middot; Email + Messenger support\n    </p>\n  </div>\n</aside>";
      var block = wrapper.firstChild;
      if (footer && footer.parentNode) {
        footer.parentNode.insertBefore(block, footer);
      } else {
        document.body.appendChild(block);
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', inject);
    } else {
      inject();
    }
  })();

} catch (e) { if (window.console && console.warn) { console.warn('APWブロック #6 で例外が出ましたが、他の機能は続行します:', e); } }

/* ===== 元 head の script #7：為替レートの概算表示 ===== */
try {

;(function(){
    var CACHE_KEY = 'apw_rates_v1';
    var CACHE_TTL = 24 * 60 * 60 * 1000; // 24h

    function readCache() {
      try {
        var raw = localStorage.getItem(CACHE_KEY);
        if (!raw) return null;
        var obj = JSON.parse(raw);
        if (Date.now() - obj.t > CACHE_TTL) return null;
        return obj.rates;
      } catch(e) { return null; }
    }
    function writeCache(rates) {
      try { localStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), rates: rates })); } catch(e){}
    }

    function fetchRates() {
      var cached = readCache();
      if (cached) return Promise.resolve(cached);
      return fetch('https://open.er-api.com/v6/latest/USD')
        .then(function(r){ return r.json(); })
        .then(function(d){
          if (d && d.rates) {
            var keep = { EUR: d.rates.EUR, GBP: d.rates.GBP, CAD: d.rates.CAD, AUD: d.rates.AUD };
            writeCache(keep);
            return keep;
          }
          return null;
        })
        .catch(function(){ return null; });
    }

    function getUsdPrice() {
      // Try meta tag first (Empire writes meta og:product:price:amount)
      var meta = document.querySelector('meta[property="og:product:price:amount"], meta[property="product:price:amount"]');
      if (meta) {
        var v = parseFloat(meta.getAttribute('content'));
        if (!isNaN(v) && v > 0) return v;
      }
      // Try product JSON on page (some themes inject)
      var pjson = document.querySelector('script[type="application/json"][data-product-json], #ProductJson-product-template');
      if (pjson) {
        try {
          var p = JSON.parse(pjson.textContent);
          if (p && p.price) return p.price / 100;
        } catch(e){}
      }
      // Try Shopify global
      if (window.meta && window.meta.product && window.meta.product.variants && window.meta.product.variants[0]) {
        return window.meta.product.variants[0].price / 100;
      }
      // Try fetching /products/{handle}.js
      return null;
    }

    function getUsdPriceAsync() {
      var sync = getUsdPrice();
      if (sync) return Promise.resolve(sync);
      var m = window.location.pathname.match(/\/products\/([a-z0-9-]+)/i);
      if (!m) return Promise.resolve(null);
      return fetch('/products/' + m[1] + '.js')
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(p){ return p ? (p.price / 100) : null; })
        .catch(function(){ return null; });
    }

    function fmt(amount, code, symbol) {
      try {
        return symbol + amount.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      } catch(e) { return symbol + Math.round(amount); }
    }

    function render(usdPrice, rates) {
      var form = document.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      if (form.querySelector('.apw-currency-est')) return;
      if (!usdPrice || usdPrice < 100) return; // skip if no price or under $100 (variant placeholder)
      if (!rates) return;

      var box = document.createElement('div');
      box.className = 'apw-currency-est';
      box.innerHTML = '<span class="apw-currency-est-label">Approx. in your currency</span>' +
                     '<span class="apw-currency-est-list">' +
                       '<span class="apw-cur">EUR <strong>' + fmt(usdPrice * rates.EUR, 'EUR', String.fromCharCode(8364)) + '</strong></span>' +
                       '<span class="apw-cur">GBP <strong>' + fmt(usdPrice * rates.GBP, 'GBP', String.fromCharCode(163)) + '</strong></span>' +
                       '<span class="apw-cur">CAD <strong>' + fmt(usdPrice * rates.CAD, 'CAD', 'C$') + '</strong></span>' +
                       '<span class="apw-cur">AUD <strong>' + fmt(usdPrice * rates.AUD, 'AUD', 'A$') + '</strong></span>' +
                     '</span>' +
                     '<small class="apw-currency-est-note">Estimated daily rate. You will be charged in USD at checkout.</small>';

      // Insert above price or at top of form
      var price = document.querySelector('.product-price, .product__price, [data-product-price], .price__current');
      if (price && price.parentNode) {
        price.parentNode.insertBefore(box, price.nextSibling);
      } else {
        form.insertBefore(box, form.firstChild);
      }
    }

    function init() {
      // Only on product pages
      if (!window.location.pathname.match(/\/products\//)) return;
      Promise.all([getUsdPriceAsync(), fetchRates()]).then(function(arr){
        render(arr[0], arr[1]);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

} catch (e) { if (window.console && console.warn) { console.warn('APWブロック #7 で例外が出ましたが、他の機能は続行します:', e); } }

/* ===== 元 head の script #8：最近見た商品 ===== */
try {

;(function(){
    var KEY = 'apw_recently_viewed';
    var MAX = 12;
    function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e){ return []; } }
    function write(arr) { localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX))); }

    // Record visit on PDP
    function record() {
      var m = window.location.pathname.match(/\/products\/([a-z0-9-]+)/i);
      if (!m) return;
      var handle = m[1];
      var arr = read().filter(function(h){ return h !== handle; });
      arr.unshift(handle);
      write(arr);
    }

    // Render section
    function render() {
      var arr = read();
      // Exclude current product on PDP
      var curr = (window.location.pathname.match(/\/products\/([a-z0-9-]+)/i) || [])[1];
      var list = arr.filter(function(h){ return h !== curr; }).slice(0, 6);
      if (list.length < 2) return; // need at least 2 to show

      var section = document.createElement('section');
      section.className = 'apw-recent';
      section.innerHTML = '<h2>Recently Viewed</h2><div class="apw-recent-grid" id="apw-recent-grid"></div>';

      // Insert after main content
      var anchor = document.querySelector('main, #MainContent, .main-content, .page-width');
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(section, anchor.nextSibling);
      } else {
        document.body.appendChild(section);
      }

      var grid = section.querySelector('#apw-recent-grid');
      Promise.all(list.map(function(h){
        return fetch('/products/' + h + '.js')
          .then(function(r){ return r.ok ? r.json() : null; })
          .catch(function(){ return null; });
      })).then(function(prods){
        var html = '';
        prods.forEach(function(p){
          if (!p) return;
          var img = (p.featured_image || (p.images && p.images[0]) || '').replace(/^https?:/, '').replace(/\.(jpg|jpeg|png)/, '_300x.$1');
          var price = '$' + (p.price / 100).toFixed(0);
          html += '<div class="apw-recent-card">' +
                    '<a href="' + p.url + '">' +
                      '<img src="' + img + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' +
                      '<p class="apw-recent-title">' + (p.title || '') + '</p>' +
                      '<p class="apw-recent-price">' + price + '</p>' +
                    '</a>' +
                  '</div>';
        });
        if (!html) { section.remove(); return; }
        grid.innerHTML = html;
      });
    }

    function init() {
      record();
      render();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

} catch (e) { if (window.console && console.warn) { console.warn('APWブロック #8 で例外が出ましたが、他の機能は続行します:', e); } }

/* ===== 元 head の script #9：スマホの固定カートバー（商品ページ） ===== */
try {

;(function(){
    if (window.innerWidth > 760) return;
    if (!window.location.pathname.match(/\/products\//)) return;

    var m = window.location.pathname.match(/\/products\/([a-z0-9-]+)/i);
    if (!m) return;
    var handle = m[1];

    fetch('/products/' + handle + '.js')
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if (!p) return;
        var variant = p.variants && p.variants[0];
        if (!variant) return;

        var bar = document.createElement('div');
        bar.className = 'apw-sticky-cart';
        bar.setAttribute('aria-label', 'Sticky add to cart');
        var img = (p.featured_image || (p.images && p.images[0]) || '').replace(/^https?:/, '').replace(/\.(jpg|jpeg|png)/, '_120x.$1');
        bar.innerHTML = '<img class="apw-sticky-cart-img" src="' + img + '" alt="">' +
                       '<div class="apw-sticky-cart-info">' +
                         '<div class="apw-sticky-cart-title">' + (p.title || '').replace(/"/g, '&quot;') + '</div>' +
                         '<div class="apw-sticky-cart-price">$' + (variant.price / 100).toFixed(2) + '</div>' +
                       '</div>' +
                       '<button type="button" class="apw-sticky-cart-btn" data-vid="' + variant.id + '"' + (variant.available ? '' : ' disabled') + '>' + (variant.available ? 'Add to Cart' : 'Sold out') + '</button>';
        document.body.appendChild(bar);

        // Observe original Add to Cart to toggle sticky visibility
        var origForm = document.querySelector('form[action*="/cart/add"]');
        var origBtn = origForm ? origForm.querySelector('[type="submit"], button[name="add"]') : null;

        function toggle() {
          var visible = false;
          if (origBtn) {
            var rect = origBtn.getBoundingClientRect();
            visible = rect.bottom < 0 || rect.top > window.innerHeight;
          } else {
            visible = window.scrollY > 400;
          }
          if (visible) {
            bar.classList.add('is-visible');
            document.body.classList.add('apw-sticky-cart-active');
          } else {
            bar.classList.remove('is-visible');
            document.body.classList.remove('apw-sticky-cart-active');
          }
        }
        window.addEventListener('scroll', toggle, { passive: true });
        toggle();

        bar.querySelector('.apw-sticky-cart-btn').addEventListener('click', function(){
          var btn = bar.querySelector('.apw-sticky-cart-btn');
          var origLabel = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'Adding...';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: variant.id, quantity: 1 })
          }).then(function(r){
            if (r.ok) {
              btn.textContent = 'Added!';
              setTimeout(function(){ window.location.href = '/cart'; }, 600);
            } else {
              btn.disabled = false;
              btn.textContent = origLabel;
            }
          }).catch(function(){
            btn.disabled = false;
            btn.textContent = origLabel;
          });
        });
      });
  })();

} catch (e) { if (window.console && console.warn) { console.warn('APWブロック #9 で例外が出ましたが、他の機能は続行します:', e); } }

/* ===== 元 head の script #10：商品ページの補助表示 ===== */
try {

;(function(){
    if (!window.location.pathname.match(/\/products\//)) return;
    function inject() {
      var form = document.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      if (form.querySelector('.apw-pdp-badges') || document.querySelector('.apw-pdp-badges')) return;
      var wrapper = document.createElement('div');
      wrapper.innerHTML = "<div class=\"apw-pdp-badges\" role=\"region\" aria-label=\"Purchase guarantees\">\n  <div class=\"apw-pdp-badge\">\n    <svg viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-4z\"/><path d=\"M9 12l2 2 4-4\"/></svg>\n    <span class=\"apw-pdp-badge-label\">7-Day Warranty</span>\n    <span class=\"apw-pdp-badge-sub\">On arrival</span>\n  </div>\n  <div class=\"apw-pdp-badge\">\n    <svg viewBox=\"0 0 24 24\" aria-hidden=\"true\"><rect x=\"1\" y=\"6\" width=\"15\" height=\"13\" rx=\"1\"/><path d=\"M16 10h4l3 4v5h-7\"/><circle cx=\"6\" cy=\"20\" r=\"2\"/><circle cx=\"19\" cy=\"20\" r=\"2\"/></svg>\n    <span class=\"apw-pdp-badge-label\">Pre-wired 100-120V</span>\n    <span class=\"apw-pdp-badge-sub\">USA plug-direct</span>\n  </div>\n  <div class=\"apw-pdp-badge\">\n    <svg viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z\"/></svg>\n    <span class=\"apw-pdp-badge-label\">English Support</span>\n    <span class=\"apw-pdp-badge-sub\">Email + Messenger</span>\n  </div>\n  <div class=\"apw-pdp-badge\">\n    <svg viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M12 1l3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1z\"/></svg>\n    <span class=\"apw-pdp-badge-label\">Overhauled in Japan</span>\n    <span class=\"apw-pdp-badge-sub\">Okayama atelier</span>\n  </div>\n</div>";
      var node = wrapper.firstChild;
      // Insert just before the Add to Cart submit row
      var addBtn = form.querySelector('[type="submit"], button[name="add"]');
      if (addBtn) {
        var row = addBtn.closest('.product-form__item, .product-form__buttons, .product__buttons, .product-form__controls-group') || addBtn.parentNode;
        if (row && row.parentNode) {
          row.parentNode.insertBefore(node, row);
          return;
        }
      }
      form.insertBefore(node, form.firstChild);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', inject);
    } else {
      inject();
    }
  })();

} catch (e) { if (window.console && console.warn) { console.warn('APWブロック #10 で例外が出ましたが、他の機能は続行します:', e); } }

/* ===== 元 head の script #11：カートページの処理 ===== */
try {

;(function(){
    if (!/^\/cart/.test(window.location.pathname)) return;
    function inject() {
      if (document.querySelector('.apw-cart-trust')) return;
      var wrap = document.createElement('div');
      wrap.innerHTML = "<aside class=\"apw-cart-trust\" aria-label=\"Purchase guarantees\">\n  <div class=\"apw-cart-trust-grid\">\n    <div class=\"apw-cart-trust-item\">\n      <svg viewBox=\"0 0 24 24\"><path d=\"M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-4z\"/><path d=\"M9 12l2 2 4-4\"/></svg>\n      <span class=\"apw-cart-trust-label\">7-Day Warranty</span>\n      <span class=\"apw-cart-trust-sub\">On arrival</span>\n    </div>\n    <div class=\"apw-cart-trust-item\">\n      <svg viewBox=\"0 0 24 24\"><rect x=\"1\" y=\"6\" width=\"15\" height=\"13\" rx=\"1\"/><path d=\"M16 10h4l3 4v5h-7\"/><circle cx=\"6\" cy=\"20\" r=\"2\"/><circle cx=\"19\" cy=\"20\" r=\"2\"/></svg>\n      <span class=\"apw-cart-trust-label\">Pre-wired 100-120V</span>\n      <span class=\"apw-cart-trust-sub\">USA plug-direct</span>\n    </div>\n    <div class=\"apw-cart-trust-item\">\n      <svg viewBox=\"0 0 24 24\"><path d=\"M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z\"/></svg>\n      <span class=\"apw-cart-trust-label\">English Support</span>\n      <span class=\"apw-cart-trust-sub\">Email + Messenger</span>\n    </div>\n    <div class=\"apw-cart-trust-item\">\n      <svg viewBox=\"0 0 24 24\"><path d=\"M12 1l3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1z\"/></svg>\n      <span class=\"apw-cart-trust-label\">Overhauled in Japan</span>\n      <span class=\"apw-cart-trust-sub\">Okayama atelier</span>\n    </div>\n  </div>\n  <div class=\"apw-cart-secure\">\n    <svg viewBox=\"0 0 24 24\"><rect x=\"3\" y=\"11\" width=\"18\" height=\"11\" rx=\"2\"/><path d=\"M7 11V7a5 5 0 0 1 10 0v4\"/></svg>\n    <span><strong>Secure checkout.</strong> SSL encrypted. Cards processed by Shopify Payments. Tracking number provided once your machine ships from Okayama.</span>\n  </div>\n</aside>";
      var node = wrap.firstChild;
      // Insert at the bottom of the cart form
      var form = document.querySelector('form[action="/cart"], form.cart, #cart-form, [data-cart-form]');
      if (form && form.parentNode) {
        form.parentNode.insertBefore(node, form.nextSibling);
      } else {
        var main = document.querySelector('main, #MainContent, .main-content');
        if (main) main.appendChild(node);
        else document.body.appendChild(node);
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', inject);
    } else {
      inject();
    }
  })();

} catch (e) { if (window.console && console.warn) { console.warn('APWブロック #11 で例外が出ましたが、他の機能は続行します:', e); } }

/* ===== 元 head の script #12：パチンコ実機の「玉30個同梱」注記 ===== */
try {

;(function(){
    if (!window.location.pathname.match(/\/products\//)) return;
    var m = window.location.pathname.match(/\/products\/([a-z0-9-]+)/i);
    if (!m) return;
    var handle = m[1];

    fetch('/products/' + handle + '.js')
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if (!p) return;
        // Only on traditional pachinko (type "Pachinko") - exclude Smart Pachinko (smapachi_set tag)
        if (p.type !== 'Pachinko') return;
        var tags = (p.tags || []).join(',').toLowerCase();
        if (tags.indexOf('smapachi') >= 0) return;
        // Skip product options (accessories) - they have "option" in type, already filtered by type !== "Pachinko" exact match
        if (document.querySelector('.apw-pdp-ball-note')) return;

        var note = document.createElement('div');
        note.className = 'apw-pdp-ball-note';
        note.innerHTML = '<span class="apw-pdp-ball-note-title">Includes 100 steel balls</span>' +
                       '<p>This pachinko machine ships with <strong>100 pachinko balls</strong> and a CR adapter - the standard home-play package, but not a hall-sized supply. For real sessions plan for <strong>10,000+ balls</strong>. Because balls are heavy and shipping from Japan is expensive, we recommend <a href="/pages/pachinko-ball-setup">buying additional balls on eBay</a> from a domestic seller. Alternative: install a <strong>Circulation Lifter + upper tray cover</strong> setup for ball-less continuous play. <a href="/pages/pachinko-ball-setup">See our full setup guide</a>.</p>';

        // Insert above the Add to Cart form / right after price element
        var form = document.querySelector('form[action*="/cart/add"]');
        if (form) {
          // Place at top of form (before badges / variant selector)
          var firstChild = form.firstChild;
          form.insertBefore(note, firstChild);
        } else {
          // Fallback: place above PDP description
          var desc = document.querySelector('.product-description, .product__description, [data-product-description]');
          if (desc && desc.parentNode) desc.parentNode.insertBefore(note, desc);
        }
      });
  })();

} catch (e) { if (window.console && console.warn) { console.warn('APWブロック #12 で例外が出ましたが、他の機能は続行します:', e); } }

/* ===== 元 head の script #13：実機ページのクロスセル（スタンド等） ===== */
try {

;(function(){
    if (!window.location.pathname.match(/\/products\//)) return;
    var m = window.location.pathname.match(/\/products\/([a-z0-9-]+)/i);
    if (!m) return;
    var handle = m[1];

    // Bail on the cross-sell products themselves
    var BAIL_HANDLES = ['sp-ironstand','sp-woodstand','sp-a-counter-ant','transformer','p-a_controller_plus','sp-danboaru-stand','sp-danboaru-set','sp-counter-stay','p-vega-dx','p-dataro-omega','p-dataro-giga11','p-elecs-el-sl','p-bigwooz-touch','p-panela-shutel-neo'];
    if (BAIL_HANDLES.indexOf(handle) >= 0) return;

    fetch('/products/' + handle + '.js')
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if (!p) return;
        var type = (p.type || '').toLowerCase();
        var tags = (p.tags || []).join(',').toLowerCase();
        // Only show on machine PDPs (Slot, Pachislot, Pachinko), skip option types
        if (!/^(slot|pachislot|pachinko)$/.test(type)) return;
        if (/option/.test(type)) return;

        var isPachinko = (type === 'pachinko' && !tags.includes('smapachi'));
        var isSmart = tags.includes('smapachi') || tags.includes('smaslot') || tags.includes('smart');

        // Pick 3 cross-sell handles
        var picks;
        if (isPachinko) {
          // Traditional pachinko
          picks = [
            { handle: 'sp-ironstand', tag: 'Stand' },
            { handle: 'p-a_controller_plus', tag: 'Auto-controller' },
            { handle: 'transformer', tag: '220V users only' },
          ];
        } else if (isSmart) {
          // Smart Pachinko or Smart Pachislot - no need for coin-feeder or A-Controller (already built-in)
          picks = [
            { handle: 'sp-ironstand', tag: 'Stand' },
            { handle: 'sp-a-counter-ant', tag: 'Wireless counter' },
            { handle: 'transformer', tag: '220V users only' },
          ];
        } else {
          // Traditional pachislot (Slot)
          picks = [
            { handle: 'sp-ironstand', tag: 'Stand' },
            { handle: 'p-vega-dx', tag: 'Data counter' },
            { handle: 'transformer', tag: '220V users only' },
          ];
        }

        // Fetch each pick
        Promise.all(picks.map(function(pk){
          return fetch('/products/' + pk.handle + '.js')
            .then(function(r){ return r.ok ? r.json() : null; })
            .then(function(prod){ return prod ? { p: prod, tag: pk.tag } : null; })
            .catch(function(){ return null; });
        })).then(function(arr){
          arr = arr.filter(function(x){ return x; });
          if (arr.length === 0) return;
          if (document.querySelector('.apw-crosssell')) return;

          var headSub = isPachinko ? 'Recommended accessories for traditional pachinko' :
                        isSmart ? 'Recommended accessories for Smart machines' :
                        'Recommended accessories for traditional pachislot';

          var html = '<div class="apw-crosssell">' +
                    '<div class="apw-crosssell-head"><h3>Complete Your Setup</h3>' +
                    '<span class="apw-crosssell-head-sub">' + headSub + '</span></div>' +
                    '<div class="apw-crosssell-grid">';
          arr.forEach(function(item){
            var prod = item.p;
            var img = (prod.featured_image || (prod.images && prod.images[0]) || '').replace(/^https?:/, '').replace(/\.(jpg|jpeg|png)/, '_300x.$1');
            var price = '$' + (prod.price / 100).toFixed(2);
            var title = (prod.title || '').replace(/\[[^\]]*\]/g, '').replace(/-.+$/, '').trim();
            if (title.length > 48) title = title.slice(0, 46) + '.';
            html += '<a class="apw-crosssell-card" href="' + prod.url + '">' +
                      '<div class="apw-crosssell-card-img" style="background-image:url(' + img + ')"></div>' +
                      '<p class="apw-crosssell-card-tag">' + item.tag + '</p>' +
                      '<p class="apw-crosssell-card-title">' + title + '</p>' +
                      '<p class="apw-crosssell-card-price">' + price + '</p>' +
                    '</a>';
          });
          html += '</div>';

          // Add "See all data counters" link when on a pachislot
          if (!isPachinko && !isSmart) {
            html += '<p style="margin:14px 0 0;font-size:13px;text-align:center"><a class="apw-crosssell-link" href="/pages/data-counters">See all Data Counters &amp; Lamps ?</a></p>';
          } else if (isPachinko) {
            html += '<p style="margin:14px 0 0;font-size:13px;text-align:center"><a class="apw-crosssell-link" href="/pages/pachinko-ball-setup">See pachinko ball setup guide ?</a></p>';
          }
          html += '</div>';

          var wrapper = document.createElement('div');
          wrapper.innerHTML = html;
          var node = wrapper.firstChild;

          // Insert after the Add to Cart form, before main product description
          var form = document.querySelector('form[action*="/cart/add"]');
          if (form && form.parentNode) {
            // Place just AFTER the form
            if (form.nextSibling) {
              form.parentNode.insertBefore(node, form.nextSibling);
            } else {
              form.parentNode.appendChild(node);
            }
          } else {
            // Fallback: append to main
            var main = document.querySelector('main, #MainContent, .main-content');
            if (main) main.appendChild(node);
          }
        });
      });
  })();

} catch (e) { if (window.console && console.warn) { console.warn('APWブロック #13 で例外が出ましたが、他の機能は続行します:', e); } }

/* ===== 元 head の script #16：オプション商品の説明ページ判定 ===== */
try {

;(function(){
  function isOptionProductDescriptionPage(){
    if (/\/collections\/all-options\/products\//.test(window.location.pathname)) return true;

    var scripts = document.querySelectorAll ? document.querySelectorAll('script[type="application/ld+json"]') : [];
    for (var i = 0; i < scripts.length; i += 1) {
      var text = scripts[i].textContent || '';
      if (/"category"\s*:\s*"(?:Common option|Pachinko option|Slot option)"/i.test(text)) return true;
    }

    var productJson = document.querySelector ? document.querySelector('script[type="application/json"][data-product-json], #ProductJson-product-template') : null;
    if (productJson) {
      try {
        var product = JSON.parse(productJson.textContent);
        var type = String(product.type || product.product_type || '').toLowerCase();
        if (type === 'common option' || type === 'pachinko option' || type === 'slot option') return true;
      } catch(e) {}
    }

    return false;
  }

  function hideLegacyProductDescriptionShipping(){
    if (!document.body || !document.body.classList.contains('template-product')) return;
    var isOption = isOptionProductDescriptionPage();
    var blocks = document.querySelectorAll('.product-description.rte > .shipping-info, .product-description.rte > .shopify-section > .shipping-info');

    for (var i = 0; i < blocks.length; i += 1) {
      var text = (blocks[i].textContent || '').replace(/\s+/g, ' ');
      var isOldMachineShipping = /North American shipping fee|Europe shipping fee|Asia shipping fee|Click here for other shipping fee/i.test(text);
      var isOldOptionShipping = /\[Important Notice\]|\[Shipping Fee\(Minimum Fee\)\]|temporarily increased shipping charges|shipping costs caused by the rise in airfreight rates/i.test(text);

      if (isOldMachineShipping || (isOption && isOldOptionShipping)) {
        blocks[i].classList.add('apw-hidden-legacy-shipping');
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hideLegacyProductDescriptionShipping);
  else hideLegacyProductDescriptionShipping();
}());
} catch (e) { if (window.console && console.warn) { console.warn('APWブロック #16 で例外が出ましたが、他の機能は続行します:', e); } }

